import { UnifiedGraftModelType } from '@graftcode/protocol'

import { METHOD_TYPE_BADGE_LABELS } from '@/core/const/methodTypeBadgeLabels.const'
import { UnifiedGraftModelTypeKey } from '@/core/const/unifiedGraftModelTypeKeys.const'

/** Returns badge label for method or constructor type. */
export const getBadgeLabel = (type: UnifiedGraftModelType | number | string): string | undefined => {
  const typeString = String(type)
  const typeNumber = typeof type === 'number' ? type : undefined

  if (typeString === UnifiedGraftModelTypeKey.TYPE_DEF || typeNumber === UnifiedGraftModelType.TYPE_DEF) {
    return METHOD_TYPE_BADGE_LABELS.CLASS
  }

  if (
    typeString === 'CONSTRUCTOR' ||
    typeString === 'OVERLOADED_CONSTRUCTOR' ||
    typeNumber === UnifiedGraftModelType.CONSTRUCTOR ||
    typeNumber === UnifiedGraftModelType.OVERLOADED_CONSTRUCTOR
  ) {
    return 'Constructor'
  }

  if (
    typeString === 'STATIC_METHOD' ||
    typeString === 'OVERLOADED_STATIC_METHOD' ||
    typeNumber === UnifiedGraftModelType.STATIC_METHOD ||
    typeNumber === UnifiedGraftModelType.OVERLOADED_STATIC_METHOD
  ) {
    return 'Static method'
  }

  if (
    typeString === 'INSTANCE_METHOD' ||
    typeString === 'OVERLOADED_INSTANCE_METHOD' ||
    typeNumber === UnifiedGraftModelType.INSTANCE_METHOD ||
    typeNumber === UnifiedGraftModelType.OVERLOADED_INSTANCE_METHOD
  ) {
    return 'Instance Method'
  }

  if (
    typeString === 'GLOBAL_METHOD' ||
    typeString === 'OVERLOADED_GLOBAL_METHOD' ||
    typeNumber === UnifiedGraftModelType.GLOBAL_METHOD ||
    typeNumber === UnifiedGraftModelType.OVERLOADED_GLOBAL_METHOD
  ) {
    return 'Global method'
  }

  console.warn('Unknown method/constructor type:', type, typeof type)
  return undefined
}
